import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

interface LecturerDetailProps {
  id: number;
  onUpdateCompleted?: () => void;
}

const useLecturerDetail = ({id, onUpdateCompleted}:LecturerDetailProps) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lecturerInfo, setLecturerInfo] = useState<LecturerListDto>();

  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.lecturer.info, {id: id}],
    () =>
      fetcher.lecturer.postLecturerInfo({id: id}),
    {
      onSuccess: (res: LecturerInfoResDto) => {
        switch (res.code) {
          case 200:
            setLecturerInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: lecturerInsert } = useMutation(
    [endpoints.lecturer.add],
    fetcher.lecturer.postLecturerAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            onUpdateCompleted?.();
            break;
          case 100:
            message.error("중복된 이름이 존재 합니다.", 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: lecturerUpdate } = useMutation(
    [endpoints.lecturer.update],
    fetcher.lecturer.postLecturerUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            onUpdateCompleted?.();
            break;
          case 100:
            message.error("중복된 이름이 존재 합니다.", 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: lecturerActivate } = useMutation(
    [endpoints.lecturer.activate],
    fetcher.lecturer.postLecturerActivate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            onUpdateCompleted?.();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: lecturerDelete} = useMutation(
    [endpoints.lecturer.update],
    fetcher.lecturer.postLecturerDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            onUpdateCompleted?.();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { isLoading, lecturerInfo, lecturerInsert, lecturerUpdate, lecturerDelete, lecturerActivate  };
};

export default useLecturerDetail;
